import React from 'react'
import { UserRole } from '@modmd/data'
import { Tabber } from 'components/Tabber'
import Card from 'components/Card'
import { CompaniesUser } from 'sharedComponents/CompaniesUser'
import { GroupsUser } from 'sharedComponents/GroupsUser'

export interface Params {
  userId: string
}

enum BusinessTabberType {
  Companies = 'Companies',
  Groups = 'Groups',
}

export const BusinessUser = ({ userId }: Params) => {
  const displayTab = () => BusinessTabberType.Companies
  const [showedDatalist, setShowedDatalist] = React.useState<string>(displayTab)
  return (
    <Card borderRadius="0">
      <Tabber
        activeTabName={showedDatalist}
        onChange={({ activeTabName }) => {
          setShowedDatalist(activeTabName)
        }}
      >
        <Tabber.Item
          tabName={BusinessTabberType.Companies}
          permissions={[UserRole.SUPER_ADMIN as UserRole]}
          component={<CompaniesUser userId={userId} />}
        >
          Companies
        </Tabber.Item>
        <Tabber.Item
          tabName={BusinessTabberType.Groups}
          permissions={[UserRole.SUPER_ADMIN as UserRole]}
          component={<GroupsUser userId={userId} />}
        >
          Groups
        </Tabber.Item>
      </Tabber>
    </Card>
  )
}
